import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";
import { useDesktopMediaQuery } from "Shared/Responsive";
import styled, { css } from "styled-components";
import ArrowLeftIcon from "src/components/icons/ArrowLeft";
import GarageIcon from "src/components/icons/Garage";
import "./SidebarButtons.scss";

const IconStyle = css`
    color: ${(props) => props.theme.palette.primary.main};
    display: inline-block;
    padding: 0 4px 0 0;
`;
const ArrowButtonIcon = styled(ArrowLeftIcon)`
    ${IconStyle};
    height: 13px;
    width: 11px;
`;

const GarageButtonIcon = styled(GarageIcon)`
    ${IconStyle};
    height: 22px;
    width: 27px;
`;
export const SidebarBackButton = () => {
    const history = useHistory();
    const { pathname } = useLocation();
    const { t } = useTranslation();
    const isDesktop = useDesktopMediaQuery();

    const [href, label] = (() => {
        switch (pathname) {
            case "/dealer-offer/review":
                return ["/dealer-offer", "DealerOffer.ContinueDealerOffer.ReviewPage.BackButton"];
            default:
                return ["/my-garage", "ContinueDeal.VehicleInfo.backButtonLabel"];
        }
    })();

    return (
        <div className={`SidebarButton__container`}>
            <button className={`SidebarButton__back-to-garage`} onClick={() => history.push(href)}>
                {isDesktop ? href === "/my-garage" && <GarageButtonIcon /> : <ArrowButtonIcon />}
                {t(label)}
            </button>
        </div>
    );
};

export default SidebarBackButton;
